import { useNavigate } from "react-router-dom";

/** 404 — the canvas's "Page not found" state. */
export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="state-screen" data-testid="not-found-page">
      <div className="state-mark">404</div>
      <h2>Page not found</h2>
      <p>The page you requested doesn&apos;t exist or has moved.</p>
      <button
        type="button"
        className="btn btn-secondary state-actions"
        onClick={() => navigate("/copilot")}
      >
        Back to Copilot
      </button>
    </div>
  );
}
